import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  GetAssignmentByPersonId,
  cleanAssignmentByPerson,
} from '../../store/HR/Person/assignmentSlice';
// import { useParams } from 'react-router-dom';

const useAssignmentData = (id) => {
  // const { id } = useParams();

  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const { AssignmentPerson, isLoading, error2 } = useSelector((state) => state.Assignments);
  useEffect(() => {
    dispatch(GetAssignmentByPersonId(id));

    return () => {
      dispatch(cleanAssignmentByPerson());
    };
  }, [dispatch, id]);

  const createDropdownData = (data) => ({
    current: data?.current,
    list: data?.list?.map((item) => ({
      value: item.id,
      label: i18n.language === 'en' ? item.name : item.name2,
    })),
  });

  const Data = {
    id: AssignmentPerson.id,
    name: AssignmentPerson.name,
    name2: AssignmentPerson.name2,
    startDate: AssignmentPerson.startDate,
    endDate: AssignmentPerson.endDate,
  };

  const allAssignment = AssignmentPerson && AssignmentPerson?.allAssignment;
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const Grade = createDropdownData(AssignmentPerson?.grade);
  const Group = createDropdownData(AssignmentPerson?.group);
  const Organization = createDropdownData(AssignmentPerson?.organization);
  const Jobs = createDropdownData(AssignmentPerson?.jobs);
  const Payroll = createDropdownData(AssignmentPerson?.payroll);
  const Locations = createDropdownData(AssignmentPerson?.locations);
  const SuperVisor = createDropdownData(AssignmentPerson?.superVisor);
  const Status = createDropdownData(AssignmentPerson?.status);

  // const Position = createDropdownData(AssignmentPerson?.position);

  const Position = {
    current: AssignmentPerson?.position?.current,
    list: AssignmentPerson?.position?.list?.map((item) => ({
      value: item.id,
      label: i18n.language === 'en' ? item.name : item.name2,
      isDisabled: item.headcount <= item.filledHeadcount, // تعطيل الخيار اذا كان لم يكن هناك شاغر
      jobId: item.jop,
      organizationId: item.organizationId,
      locationId: item.locationId,
      headcount: item.headcount,
      filledHeadcount: item.filledHeadcount,
      firstEndDateAssinment: null,
    })),
  };
  return {
    isLoading,
    error2,
    Data,
    Grade,
    Group,
    Organization,
    Jobs,
    Position,
    Payroll,
    Locations,
    SuperVisor,
    Status,
    allAssignment,
  };
};

export default useAssignmentData;
